import React, { useContext, useState } from 'react';
import Icons from '../Icons';
import { Context } from "../contexts/AppContext";
import { postData, putData } from '../../lib/utils';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

function UploadMusicBg(props) {
  const [audioFile, setAudioFile] = useState(null);
  
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [clickType, setClickType]=useState(null)
  const [musicurl, setmusicUrl] = useState();
  const { galleryId } = useParams();

  const { currentFolderData, currentFolderName, currentGalleryName,currentGalleryData } = appState;

  console.log(appState?.adminDetails," DKJKDJFKFD ",currentFolderData, currentFolderName, currentGalleryName,currentGalleryData)


    const deleteMusicBg=async()=>{
  
  
         try { 
                  const filePath =appState?.currentGalleryData?.backgroundMedia?.musicUrl;
                        const _json = await postData("products/delete-file", {
                         fileName:filePath
                        })
                        if (_json) {
                         console.log("Delete Gallery");
                         
      const json = await putData(`galleries/gallery/${galleryId}/background`, {
        musicUrl: null
      });
  
      if (json) {
                  // Update both appState and local state for instant preview
                  setAppState((prevState) => ({
                    ...prevState,
                    currentGalleryData: {
                      ...prevState.currentGalleryData,
                      backgroundMedia: {
                        ...prevState.currentGalleryData.backgroundMedia,
                        musicUrl: json.backgroundMedia.musicUrl
                      }
                    }
                  }));
                  setmusicUrl(json.backgroundMedia.musicUrl);
                 props.deleteFile()
  
                }
                        }
                     } catch (error) {
                       console.error("Error deleting file:", error);
                     }
  }

const handleFileChange = async (event) => {
  const file = event.target.files[0];

  if (!file) return;


  const allowedTypes = [
    "audio/mpeg", // mp3
    "audio/wav",
    "audio/x-wav",
    "audio/aac",
    "audio/ogg",
  ];

  if (!allowedTypes.includes(file.type)) {
    alert("Only MP3, WAV, AAC, and OGG files are allowed.");
    event.target.value = "";
    return;
  }

  const fileSizeMB = file.size / (1024 * 1024);

  const availableCreditsMB =
    appState?.adminDetails?.credits || 0;

  if (fileSizeMB > 40) {
    alert(
      `❌ File too large (${fileSizeMB.toFixed(
        2
      )} MB). Maximum allowed size is 40 MB.`
    );
    return;
  }

  if (fileSizeMB > availableCreditsMB) {
    alert(
      `⚠️ Not enough credits!\n\nFile size: ${fileSizeMB.toFixed(
        2
      )} MB\nAvailable credits: ${availableCreditsMB.toFixed(
        2
      )} MB`
    );
    return;
  }

  setAudioFile(file);

  await handleUpload(file);
};


  
  // Upload to S3
const handleUpload = async (file) => {
  try {
    props.handleUpload?.(file);

    const cleanName = file.name.replace(/[^a-zA-Z0-9_.-]/g, "_");

    const s3Key = `${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}/${cleanName}`;

    const chunkSize = 5 * 1024 * 1024;
    const totalParts = Math.ceil(file.size / chunkSize);

    // Start Multipart Upload
    const { uploadId } = await postData(
      `products/start-multipart-upload?fileName=${encodeURIComponent(
        s3Key
      )}&fileType=${encodeURIComponent(file.type)}`
    );

    let parts = [];

    for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
      const start = (partNumber - 1) * chunkSize;
      const end = Math.min(start + chunkSize, file.size);

      const chunk = file.slice(start, end);

      const { url } = await fetch(
        `${process.env.REACT_APP_API_PATH}products/get-part-url?fileName=${encodeURIComponent(
          s3Key
        )}&uploadId=${uploadId}&partNumber=${partNumber}`
      ).then((res) => res.json());

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open("PUT", url, true);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const percent = Math.round(
              (event.loaded / event.total) * 100
            );

            props.audioOnPrg?.(percent);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            const eTag = xhr.getResponseHeader("ETag");

            parts.push({
              ETag: eTag,
              PartNumber: partNumber,
            });

            resolve();
          } else {
            reject(`Upload failed (${xhr.status})`);
          }
        };

        xhr.onerror = () => reject("Network error");

        xhr.send(chunk);
      });
    }

    // Complete Upload
    await fetch(
      `${process.env.REACT_APP_API_PATH}products/complete-multipart-upload`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fileName: s3Key,
          uploadId,
          parts,
        }),
      }
    );

    
    // Save path in DB
    const json = await putData(
      `galleries/gallery/${galleryId}/background`,
      {
        musicUrl: s3Key,
      }
    );

    if (json) {
      setAppState((prev) => ({
        ...prev,
        currentGalleryData: {
          ...prev.currentGalleryData,
          backgroundMedia: {
            ...prev.currentGalleryData.backgroundMedia,
            musicUrl: json.backgroundMedia.musicUrl,
          },
        },
      }));

      setmusicUrl(json.backgroundMedia.musicUrl);
    }

    props.audioUploadedDone?.(file);
  } catch (error) {
    console.error("Music upload error:", error);
    props.uploadFailed?.(file);
  }
};
  // Optional: Delete from S3
  const deleteFileFromS3 = async (fileName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/products/delete-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fileName }),
      });

      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
  <div className='flex '>
      <input
        type="file"
        accept="audio/*"
        onChange={handleFileChange}
        id="audioInput"
        style={{ display: "none" }}
      />
      <button
        type="button"
        onClick={() => {
          console.log("Upload button clicked!");
          document.getElementById("audioInput").click();
        }}
        className="btn-yellow flex gap-4 justify-center"
      >
        <Icons.Uploads /> Upload Music
      </button>    
        <FontAwesomeIcon  
          icon={faTrash} 
          onClick={deleteMusicBg}
          style={{ color: "white", backgroundColor:'#1F2937', border:'1px solid', padding:'12px' ,cursor:"pointer" }} 
          className="ml-2 flex-shrink-0"
        />
    </div>
  );
}

export default UploadMusicBg;
